import { render, staticRenderFns } from "./ArrearsExerciseGrid.vue?vue&type=template&id=923a5aea"
import script from "./ArrearsExerciseGrid.vue?vue&type=script&lang=js"
export * from "./ArrearsExerciseGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports